import functions from "./functions.js";

$(function () {

    const $form = $('.booking-form');
    const form = $form[0];

    if (!form) {
        return;
    }

    const booking = {
        $form: null,
        $payment: null,
        $calculation: null,
        $partnerCodeSuccess: null,
        $partnerCodeError: null,
        calc: [],
        persons: null,
        promoDiscount: null,
        totalAmount: null,
        totalAmountConverted: null,
        insurance: null,
        status: null,

        init() {

            booking.$form = $(".booking-form");
            booking.$calculation = $(".table-calculation");
            booking.$payment = $(".payment-details");
            booking.$partnerCodeSuccess = $(".partnerCodeSuccess");
            booking.$partnerCodeError = $(".partnerCodeError");
            booking.showUniCredit = $('[data-unicreditoffer]').length;

            $.get('/opsti-uslovi-putovanja/').then(response => {
                const $html = $('<div>').html(response)
                $(".modal-body-content.travelConditions").html($html.find('main#primary').html());
                $(".modal-body-content.travelConditions").find('#hero').remove();
            });

            $.get('/uslovi-kupovine/').then(response => {
                const $html = $('<div>').html(response)
                $(".modal-body-content.termsOfPurchase").html($html.find('main#primary').html());
                $(".modal-body-content.termsOfPurchase").find('#hero').remove();
            });

            if ($(".modal-body-content.uniCreditTerms").length) {
                $.get('/pravila-za-ostvarenje-popusta-unicredit-banke/').then(response => {
                    const $html = $('<div>').html(response)
                    $(".modal-body-content.uniCreditTerms").html($html.find('main#primary').html());
                    $(".modal-body-content.uniCreditTerms").find('#hero').remove();
                });
            }


            $('[data-bs-div]').click(function (e) {
                $('.modal-body-content').addClass('d-none');
                $('.modal-title > span').addClass('d-none');
                $('.modal-body-content.' + $(this).attr('data-bs-div')).removeClass('d-none');
                $('.modal-title > span.' + $(this).attr('data-bs-div')).removeClass('d-none');
            });

            booking.params = {};

            booking.$calculation.find("*[data-calc]").each(function (index) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;
                booking.calc.push(item);
            });

            booking.$calculation.find('input[type="checkbox"]').change(function (e) {
                let $row = $(this).closest('.calc-item');
                let $quantity = $row.find('[name=quantity]');
                let value = +$quantity.val();
                let checked = $(this).is(':checked') ? 1 : 0;

                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (!checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(this));
            });



            booking.$calculation.find('select.quantity').change(function (e) {
                let $row = $(this).closest('tr');
                let $checkbox = $row.find('input[type="checkbox"]');
                let value = +$(this).val();

                if (value && !$checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if (!value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(this));
            });

            booking.total();

            booking.$form.on('submit', e => {
                booking.submit();
            });

            // BOOKING PAYMENT TYPE CHECKBOX
            if($('[name="paymentType"]')[0]) {
                checkPaymentType();
                $('[name="paymentType"]').on('change', e => {
                    checkPaymentType();
                });

                function checkPaymentType() {
                    $('[name="paymentType"]').each((index, item) => {
                        const $item = $(item);
                        const id = $item.attr('id');
                        $('[for=' + id + ']').find('[id='  + id + ']').prop('checked', $item.is(':checked'));
                    });

                    if (booking.showUniCredit) {

                        $(".promoDiscountItem").remove();

                        let promoDiscountItem = JSON.parse($(".calc-item:first").attr('data-calc'));
                        let promoDiscountItemId = promoDiscountItem.id + '_' + 114;
                        let uniCreditDiscountAmount = +$('[data-uniCreditDiscountAmount]').attr('data-unicreditdiscountamount');

                        $.each(booking.calc, function (key, calc) {
                            if (calc && calc.id == promoDiscountItemId) {
                                booking.calc.splice(key, 1);
                            }
                        });
                        booking.total();

                        if ($('[name="paymentType"]:checked').val() == 'uniCreditCard' || $('[name="paymentType"]:checked').val() == 'uniCreditCardAgency') {
                            booking.applyDiscount(uniCreditDiscountAmount,  0, true, 'UniCredit bonus vaucer');
                        }
                    }
                }

            }

            $('#partnerCodeApply').on('click', function (e) {
                e.preventDefault();

                let params = functions.getUrlData(false);
                let code = $("[name='partnerCode']").val();
                let publicId = $("[name='publicId']").val();

                if (code.indexOf('SA', 0) != -1)
                {
                    booking.$partnerCodeSuccess.removeClass('d-none');
                    booking.$partnerCodeError.addClass('d-none');

                    return;
                }

                params.language = functions.getLang();
                params.promoCode = code;
                params.publicId = publicId;

                booking.$partnerCodeSuccess.addClass('d-none');
                booking.$partnerCodeError.addClass('d-none');

                $.get('/services/promoCode/', $.param(params)).then(response => {
                    response = JSON.parse(response);
                    booking.$calculation.find(".promoDiscountItem").remove();

                    if (response.status && (+response.amount || +response.percent)) {
                        booking.$partnerCodeSuccess.removeClass('d-none');
                        booking.$partnerCodeError.addClass('d-none');

                        booking.applyDiscount(response.amount,  response.percent, response.perPerson, 'Promo kod ' + code);
                        //booking.applyDiscount(params['promoCode'], response.amount, false);
                    } else {
                        booking.$partnerCodeSuccess.addClass('d-none');
                        booking.$partnerCodeError.removeClass('d-none');
                    }
                });
            });

        },
        applyDiscount(amount,  percent, promoPerPerson, itemTitle) {

            let promoDiscountItem = JSON.parse($(".calc-item:first").attr('data-calc'));
            let promoDiscountItemId = promoDiscountItem.id + '_' + 114;

            let total = 0;

            $.each(booking.calc, function (key, calc) {
                if (calc && calc.inCalc && calc.itemDefinitionId.categoryId.key == 'baseRate') {
                    total += +calc.price * +calc.quantity;
                }
                if (calc && calc.id == promoDiscountItemId) {
                    booking.calc.splice(key, 1);
                }
            });

            let guests = promoDiscountItem.guests.split(',');
            guests = +guests[0] + +guests[1];

            //console.log(promoPerPerson);
            //console.log(guests);

            let discountAmountPrice = 0.00;
            if (+amount) {
                discountAmountPrice = (-1 * amount);
            } else {
                discountAmountPrice = (-1 * (total * (percent/100)));
            }
            //console.log(percent);
            //console.log(total);

            promoDiscountItem.id = promoDiscountItemId;
            promoDiscountItem.itemDefinitionId.id = 105;

            promoDiscountItem.itemDefinitionId.text = itemTitle;
            promoDiscountItem.itemTitle = {
                name_sr: itemTitle
            };


            promoDiscountItem.quantity = (promoPerPerson ? guests : 1);
            promoDiscountItem.itemDefinitionId.categoryId.id = 4;
            promoDiscountItem.itemDefinitionId.categoryId.key = 'discount';
            promoDiscountItem.itemDefinitionId.objectGroupId.id = 6;
            promoDiscountItem.itemDefinitionId.objectGroupId.key = 'excursions';
            promoDiscountItem.itemDefinitionId.typeId.id = 3;
            promoDiscountItem.itemDefinitionId.typeId.key = 'discount';
            promoDiscountItem.priceIn = discountAmountPrice;
            promoDiscountItem.price = discountAmountPrice;
            promoDiscountItem.totalIn = discountAmountPrice * promoDiscountItem.quantity;
            promoDiscountItem.total = discountAmountPrice * promoDiscountItem.quantity;
            promoDiscountItem.skipCalculate = true;
            promoDiscountItem.inCalc = true;

            $('<div class="calc-item py-1 border-bottom promoDiscountItem" data-calc=\'' + JSON.stringify(promoDiscountItem) + '\'>\n' +
                '    <div class="row ">\n' +
                '        <div class="col">\n' +
                '                            <div class="small">' + itemTitle + '</div>\n' +
                '            \n' +
                '            <input name="quantity" type="hidden" value="">\n' +
                '            \n' +
                '            \n' +
                '        </div>\n' +
                '        \n' +
                '        \n' +
                '                    <div class="col-auto text-end">\n' +
                '                <div class="">\n' +
                '                    <span class="item-total-amount">' + functions.formatMoney( promoDiscountItem.total, 2, ',', '.') + '</span> KM\n' +
                '                </div>\n' +
                '            </div>\n' +
                '            </div>\n' +
                '\n' +
                '</div>').insertAfter($(".calc-item-mandatory:last"));

            booking.calc.push(promoDiscountItem);
            booking.calculate($(".promoDiscountItem"));

        },
        submit() {

            $.each(booking.calc, function(key, item) {

                if ( ! item.inCalc) {
                    delete booking.calc[key];
                } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                    if ($(".guests").length) {
                        let g = item.guests.split(',');

                        let guests = [];
                        let i = 0;
                        $(".guests .row").each(function( index ) {
                            guests[i] = {
                                firstName : $(this).find("*[name='guestFirstName']").val(),
                                lastName : $(this).find("*[name='guestLastName']").val(),
                                birthDate : $(this).find("*[name='birthDateYear']").val() + '-' + $(this).find("*[name='birthDateMonth']").val() + '-' + $(this).find("*[name='birthDateDay']").val()
                            };
                            i++;
                        });

                        booking.calc[key].guestsData = guests;
                    }
                }
            });

            let paymentType = booking.$payment.find("[name='paymentType']:checked").val();
            paymentType = paymentType == 'uniCreditCard' ? 'creditCard' : paymentType;
            booking.params.paymentType = paymentType ? paymentType : 'bankTransfer';
            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            $.each(booking.params, function (key, param) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });

        },
        calculate($elem) {
            let $row = $elem.closest('.calc-item');

            let $checkbox = $row.find('input[type="checkbox"]');
            let checked = $checkbox.is(':checked') ? 1 : 0;
            let id = $checkbox.attr('id');

            let $quantity = $row.find('select.quantity:visible');
            let quantity = null;

            if ($quantity.length) {
                quantity = +$quantity.val();
            }

            $.each(booking.calc, function (key, calc) {
                if (calc.id == id) {
                    //console.log(calc);

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);
                    booking.calc[key].totalConverted = booking.itemTotalConverted(booking.calc[key]);

                    $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                    $row.find('.item-total-amount-converted').html(functions.formatMoney(booking.calc[key].totalConverted, 2, ',', '.'));
                }
            });


            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek', 'Once']) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        itemTotalConverted(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek', 'Once']) > -1) {
                    itemTotal = +item.quantity * +item.priceConverted;
                } else {
                    itemTotal = +item.priceConverted;
                }
            } else {
                itemTotal = +item.quantity * +item.priceConverted;
            }

            return itemTotal;
        },
        total() {

            const $confirmation = $('[data-confirmationPayment]');
            const advancePaymentPercent = $('[data-advancePaymentPercent]').attr('data-advancepaymentpercent');
            const persons = $("[data-guests]").attr("data-guests");

            let totalAmount = 0.00;
            let totalAmountConverted = 0.00;
            let advance = 0.00;
            let rest = 0.00;
            let confirmationPaymentWithPercent = 0.00;

            /* advanceConfirmationAmount: past due date */
            let advanceConfirmationAmount = $('[data-advanceconfirmationamount]').length ? $('[data-advanceconfirmationamount]').attr('data-advanceconfirmationamount') : 0;
            let uniCreditPayment = $('[name="paymentType"]:checked').val() == 'uniCreditCard' || $('[name="paymentType"]:checked').val() == 'uniCreditCardAgency';

            $.each(booking.calc, function (key, calc) {
                //console.log(calc);
                if (calc && !calc.onSpot && calc.inCalc) {
                    totalAmount += booking.itemTotal(calc);
                    totalAmountConverted += booking.itemTotalConverted(calc);
                }
            });

            $('.total-amount').html(functions.formatMoney(totalAmount, 2, ',', '.'));
            $('.total-amount-converted').html(functions.formatMoney(totalAmountConverted, 2, ',', '.'));

            /* valid confirmation */
            if ($confirmation.length)
            {
                let confirmationPayment = $confirmation.attr('data-confirmationpayment');
                let confirmationPercent = $confirmation.attr('data-confirmationPercent');

                if (confirmationPercent) {
                    confirmationPaymentWithPercent = totalAmount * (confirmationPercent / 100);
                    $confirmation.html(functions.formatMoney(confirmationPaymentWithPercent, 2, ',', '.'));
                } else {
                    totalAmount -= +confirmationPayment;
                }
            }

            if (+advanceConfirmationAmount) {
                if (uniCreditPayment) {
                    advance = ((((totalAmount - advanceConfirmationAmount) * (advancePaymentPercent / 100))) + +advanceConfirmationAmount) / persons;
                } else {
                    advance = ((totalAmount - advanceConfirmationAmount) * (advancePaymentPercent / 100)) + +advanceConfirmationAmount;
                }
            } else {
                advance = (totalAmount * (advancePaymentPercent / 100));
            }

            rest = totalAmount - advance - confirmationPaymentWithPercent;

            $('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
            $('.rest').html(functions.formatMoney(rest, 2, ',', '.'));
        }
    }

    booking.init();
});